export interface CreateCategory {
    isDraft: boolean
    isActive: boolean
    names: {
        [key: string]: string
    }
    parentId: string
    type: string
}

export class CreateCategoryFactory {
    static create(): CreateCategory {
        return {
            isDraft: false,
            isActive: false,
            names: {
                hr: "",
                en: "",
            },
            parentId: "",
            type: "Award",
        }
    }
}
